const baseGoogleRouteUrl = 'https://www.google.com/maps/dir/?api=1';

class LocationUtils
{
    static generateRouteUrl = (address: string): string => {
        return baseGoogleRouteUrl + `&destination=${encodeURIComponent(address)}`;
    }

}

export default LocationUtils;
